import type { Action } from 'core/use-cases/utilities';
import { useDispatch } from 'core/use-cases/utilities/lib';

/**
 * Export a hook that dispatches any action.
 *
 */
export function useCommand() {
  const dispatch = useDispatch();

  function dispatchCommand<T extends Action>(action: T) {
    dispatch(action);
  }

  return { dispatchCommand };
}
